import * as React from "react";
import * as ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { StopwatchProvider } from "./context/StopwatchContext";


ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <StopwatchProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </StopwatchProvider>
    </React.StrictMode>
);
